module.exports = __webpack_public_path__ + "img/laetherstrip.aa0eab22.jpg";